/**
 * API utility functions for common API operations
 */

/**
 * Determines the API base URL based on the current environment
 * Uses localhost URL for development, current origin for production
 */
export function getApiBaseUrl(): string {
  const isLocalhost = window.location.hostname === 'localhost';

  return isLocalhost
    ? 'https://localhost:7065/'
    : `${window.location.origin}/`;
}

/**
 * Builds a complete API URL from a relative path
 * @param path - The API path (e.g., 'api/Utility/AuthConfiguration')
 * @returns Complete URL to the API endpoint
 */
export function buildApiUrl(path: string): string {
  const baseUrl = getApiBaseUrl();
  const cleanPath = path.startsWith('/') ? path.slice(1) : path;

  return `${baseUrl}${cleanPath}`;
}
